import { createFileRoute } from '@tanstack/react-router';
import { OrgMemberDetailPage } from '@/pages/organization/org-members/OrgMemberDetailPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/organization/org-members/$orgMemberId')({
  loader: createEntityBreadcrumbLoader('orgMember', 'orgMemberId'),
  component: RouteComponent
});

function RouteComponent() {
  const { orgMemberId } = Route.useParams();
  return <OrgMemberDetailPage orgMemberId={orgMemberId} />;
}
